<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span :class="btnclass">Logout</span>
        <v-icon
            :color="color"
        >
            mdi-logout
        </v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            userAdmin: 'admin/getUserAdmin',
        }),

        color () {
            if(this.userAdmin) return 'white';
            return 'primary'
        },

        btnclass () {
            if(this.userAdmin) return 'mr-2 white--text'
            return 'mr-2 primary--text'
        }
    },

    methods: {
        ...mapActions({
            signOut: 'auth/signOut'
        }),

        ...mapMutations({
            setOverlay: 'termReports/setProgressOverlay',
            setStep: 'auth/setStep',
            setExpand: 'auth/setExpand',
        }),

        async logOut () {            
            this.setOverlay(true);
            this.setStep(1);
            await this.signOut();
            this.setExpand(true);
            //console.log("logout complete");
            if(this.userAdmin){
                this.$router.replace('/admin');
                this.$store.dispatch('logout');
                return;
            }
            this.$router.replace('/')
            this.$store.dispatch('logout');
        }

        
    }
}
</script>